/* eslint-disable max-lines */
import {contactsPdp} from 'features/contacts/reducers/index';
import {connectRouter} from 'connected-react-router';
import {History} from 'history';

import {quickCheckoutBuyNowPopup} from 'features/quickCheckout/reducers/checkout/buyNowPopup/buyNowPopup';
import {quickCheckout} from 'features/quickCheckout/reducers/checkout/quick/quick';
import {activeFilters as categoryActiveFilters} from 'features/categoryRefinements/reducers/category/activeFilters/activeFilters';
import {createdOrder} from 'features/uploadRx/reducers/createdOrder/createdOrder';
import {wizard} from 'reducers/wizard/wizard/wizard'; // current wizard product
import {wizardMs} from 'features/wizardMs/reducers';
import visibilityMenu from './menu/visibilityMenu';
import checkout from './checkout/checkout';
import shippingMethod from './checkout/shippingMethod/shippingMethod';
import shippingMethodActive from './checkout/shippingMethodActive/shippingMethodActive';
import paymentMethods from './checkout/paymentMethods/paymentMethods';
import paymentMethodActive from './checkout/paymentMethodActive/paymentMethodActive';
/* join all customer reducers into the single reducer */
import customer from './customer/customer';
import joinClub from './customer/joinClub';
import {wishlist} from './wishlist/wishlist';
import addresses from './checkout/addresses/addresses';
import currentShippingAddress from './checkout/currentShippingAddress/currentShippingAddress';
import currentBillingAddress from './checkout/currentBillingAddress/currentBillingAddress';
import orderReview from './checkout/orderReview/orderReview';
import customPopup from './cms/customPopup';
import hto from './hto';
import {oAuth} from './oAuth/oAuth';
import {currentProducts} from './currentProducts/currentProducts';
// information about current page
import routerInfo from './routerInfo/routerInfo';
// category
import category from './category/category'; // get category
import filters from './category/filters/filters'; // get filters
import {reorder} from '../features/reorder/reducers/reorder/reorder'; // get reorder item
import activeSort from './category/activeSort'; // get sort
import activeFilters from './category/activeFilters/activeFilters'; // get filters
import applyFilter from './category/applyFilter'; // get status apply filter
import stateFilter from './category/stateFilter'; // get state filter
import stateSort from './category/stateSort'; // get state sort
import categoryItems from './category/categoryItems'; // get category items
import categoryItemsCount from './category/categoryItemsCount/categoryItemsCount'; // get category count items
import numPage from './category/numPage'; // get category items
// product
import product from './product/product/product'; // current product data
import stickyPdp from './product/sticky/sticky'; // current sticky
import {discountPrice} from './product/discountPrice/discountPrice'; // current product data
import activeProduct from './product/productId/productId'; // current active product
import uploadFile from './product/uploadFile/uploadFile'; // save review file

import upsell from './product/upsell/upsell'; // get data for recently viewed
import activeProductReadersPower from './product/activeProductReadersPower/activeProductReadersPower';
import isNoReadersPowerError from './product/isNoReadersPowerError/isNoReadersPowerError';
// checkout
import quoteItems from './quoteItems/quoteItems';
import cartAdd from './cartAdd/cartAdd';
import payments from './payments/payments';
import upsellItems from './upsellItems/upsellItems';
import {newsletterSubscription} from './checkout/newsletterSubscription/newsletterSubscription';
// CMS
import cmsBlock from './cms/cmsBlock';
// store
import {storeInfo} from './storeInfo/storeInfo';
import monthlyPayments from './monthlyPayments/monthlyPayments';
// blog
import blogPosts from './blog/blogPosts/blogPosts';
import blogPost from './blog/blogPost/blogPost';
// app
import pageApp from './app/pageApp/pageApp';
// Search results
import {searchResults} from './searchResults/searchResults';
// Quick search
import {quickSearch} from './quickSearch/quickSearch';
// Contacts page
import {contacts} from './contacts/contacts';
// third party scripts settings
import gender from './gender/gender';
import {reviews as productReviews} from './product/reviews/reviews';
import reviewsPhotosList from './product/reviewsPhotosList/reviewsPhotosList';
import {productBanner} from './product/banner/banner';
// Try On Visibility
import {tryOnVisibility} from './tryOnVisibility/tryOnVisibility';
// Apple pay totals
import {applePayTotals} from './applePayTotals/applePayTotals';
import {previousProductIdentifier} from './product/previousProductIdentifier';
// Data Layer
import {dataLayer} from './analytics/dataLayer';
import {productHto} from './product/productHto/productHto';
// Location
import {location} from './location/location';
import {myFit} from 'features/myFit/reducers/myFit';
import collapses from './collapses/collapses';

export const reducers = {
    // A
    activeFilters,
    activeProduct,
    activeProductReadersPower,
    activeSort,
    addresses,
    applePayTotals,
    applyFilter,
    // B
    blogPost,
    blogPosts,
    // C
    cartAdd,
    category,
    categoryActiveFilters,
    categoryItems,
    categoryItemsCount,
    // category refinements feature
    checkout,
    cmsBlock,
    collapses,
    contacts,
    contactsPdp,
    createdOrder,
    currentBillingAddress,
    currentProducts,
    currentShippingAddress,
    customPopup,
    customer,
    // D
    dataLayer,
    discountPrice,
    // F
    filters,
    // G
    gender,
    // H
    hto,
    // I
    isNoReadersPowerError,
    // J
    joinClub,
    // L
    location,
    // M
    monthlyPayments,
    myFit,
    // N
    numPage,
    newsletterSubscription,
    // O
    oAuth,
    orderReview,
    // P
    pageApp,
    paymentMethodActive,
    paymentMethods,
    payments,
    previousProductIdentifier,
    product,
    productBanner,
    productHto,
    productReviews,
    // Q
    quickCheckout,
    quickCheckoutBuyNowPopup,
    quickSearch,
    quoteItems,
    reviewsPhotosList,
    routerInfo,
    // R
    reorder,
    // S
    searchResults,
    shippingMethod,
    shippingMethodActive,
    stateFilter,
    stateSort,
    stickyPdp,
    storeInfo,
    // T
    tryOnVisibility,
    // U
    uploadFile,
    upsell,
    upsellItems,
    // V
    visibilityMenu,
    // W
    wishlist,
    wizard,
    wizardMs,
};

export type ReducersType = typeof reducers;

/**
 * Root reducer
 * @param {History} history history object
 *
 * @returns {Object} redux store
 */
const rootReducer = (history: History) => ({
    router: connectRouter(history),
    ...reducers,
});

export default rootReducer;

export type ApplicationStoreType = {
    [k in keyof ReturnType<typeof rootReducer>]: ReturnType<ReturnType<typeof rootReducer>[k]>;
};
